"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dompurify = _interopRequireDefault(require("dompurify"));
var _core = require("core.ui-module_site-components");
var _OtpVerificationResponse = _interopRequireDefault(require("../../api/auth/OtpVerificationResponse"));
var _ApplicationContext = require("../../api/ApplicationContext");
var _ResendSecurityCodeLink = _interopRequireDefault(require("./ResendSecurityCodeLink"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable jsx-a11y/anchor-is-valid */
const decorateErrorMessage = msg => /*#__PURE__*/_react.default.createElement("p", {
  className: "help is-danger has-text-left"
}, msg);
const decorateModalMessage = msg => /*#__PURE__*/_react.default.createElement("p", {
  className: "has-text-left"
}, msg);
class OtpVerificationStep extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "triggerKba", e => {
      const {
        listener
      } = this.props;
      e.preventDefault();
      this.setState({
        errorMessage: '',
        isLoading: true,
        display: true,
        rawErrorMessage: null
      });
      const step = new _OtpVerificationResponse.default();
      step.neverReceivedCode = true;
      listener(this, step);
    });
    _defineProperty(this, "returnToLogin", e => {
      const {
        listener,
        history
      } = this.props;
      e.preventDefault();
      this.setState({
        errorMessage: '',
        isLoading: true
      });
      listener('InitializeAuthentication', null);
      history.push(_ApplicationContext.ApplicationContext.getLoginPath());
    });
    _defineProperty(this, "onlyNumeric", e => {
      if (e.ctrlKey && e.key.toUpperCase() === 'V') {
        return;
      }
      const re = /Delete|Backspace|Tab|[0-9]+/g;
      if (!re.test(e.key)) {
        e.preventDefault();
      }
    });
    _defineProperty(this, "hideModal", () => {
      this.setState({
        display: false
      });
    });
    this.state = {
      isLoading: false,
      resendRequested: false,
      otpCode: '',
      errorMessage: '',
      enableTrust: false,
      display: true,
      showTrustedDeviceModal: false,
      additionalData: props.stepResponse?.additionalData
    };
    this.returnToLogin = this.returnToLogin.bind(this);
    this.resend = this.resend.bind(this);
  }
  submit(e) {
    const {
      listener
    } = this.props;
    const {
      resendRequested,
      otpCode,
      enableTrust
    } = this.state;
    e.preventDefault();
    this.setState({
      errorMessage: '',
      isLoading: true,
      display: true,
      rawErrorMessage: null
    });
    const step = new _OtpVerificationResponse.default();
    step.resendRequested = resendRequested;
    step.otpCode = otpCode;
    step.enableTrust = enableTrust;
    listener(this, step);
  }
  resend(e) {
    const {
      listener
    } = this.props;
    e.preventDefault();
    this.setState({
      errorMessage: '',
      isLoading: true,
      display: true,
      rawErrorMessage: null
    });
    const step = new _OtpVerificationResponse.default();
    step.resendRequested = true;
    listener(this, step);
  }
  change(e) {
    if (e.target.name === 'trust') {
      this.setState({
        enableTrust: e.target.checked
      });
      return;
    }
    const otpCode = e.target.value;
    if (!otpCode || otpCode.length < 1) {
      this.setState({
        otpCode,
        errorMessage: 'Please enter your security code'
      });
    } else if (otpCode && otpCode.length > 6) {
      e.preventDefault();
    } else {
      this.setState({
        otpCode,
        errorMessage: null
      });
    }
  }
  validate(otpCode) {
    return this.validateLength(otpCode) && this.validateNumber(otpCode);
  }
  validateLength(otpCode) {
    return otpCode && otpCode.length === 6;
  }
  validateNumber(otpCode) {
    return /^\d+$/.test(otpCode);
  }
  render() {
    const {
      otpCode,
      rawErrorMessage,
      isLoading,
      message,
      additionalData,
      errorMessage,
      display,
      showTrustedDeviceModal
    } = this.state;
    const allowKbaLink = additionalData?.kbaAllowed || false;

    // Dynamic message that says where otp was sent
    const deliveryMethodMessage = additionalData?.message || message || 'If the email address that you provided is valid, you will receive an email containing a one-time security code.';
    const placeHolder = '6 Digit Security Code';
    const disabled = !this.validate(otpCode);
    const trustedDeviceModal = /*#__PURE__*/_react.default.createElement(_core.OkModal, {
      display: showTrustedDeviceModal,
      header: "Trust this device",
      message: /*#__PURE__*/_react.default.createElement(_core.Paragraph, {
        px: 5
      }, "If you don't want to enter a security code for two-factor authentication every time you log on select Trust this device and we'll mark that device as a trusted resource. For security reasons, trusted devices may still require a security code to be entered in certain instances. To help maintain security, we recommend that you register only devices that you use frequently. You can register multiple personal devices, but please do not register public devices. Keep in mind deleting cookies on your browser will remove a trusted device."),
      closeModalCallback: () => this.setState({
        showTrustedDeviceModal: false
      })
    });
    let errorModal = null;
    let uiErrorMessage = null;
    if (rawErrorMessage) {
      let funcRef = this.hideModal;
      let header = 'Unable to Request New Security Code';
      let fullError = rawErrorMessage;
      let buttons = null;
      if (rawErrorMessage.includes('Security code has been resent')) {
        header = 'Security Code has been Sent';
        const location = additionalData?.deliveryMethod && additionalData?.deliveryMethod === 'EMAIL' ? 'in your email' : ' on your mobile device';
        fullError = `${deliveryMethodMessage} Please look for the new security code ${location}.`;
        buttons = /*#__PURE__*/_react.default.createElement(_core.Button, {
          key: "okButton",
          onClick: e => this.hideModal(e)
        }, "Ok");
      } else if (rawErrorMessage.includes('is not allowed')) {
        buttons = /*#__PURE__*/_react.default.createElement(_core.Button, {
          key: "okButton",
          onClick: e => this.hideModal(e)
        }, "Ok");
      } else if (rawErrorMessage.includes('expired')) {
        header = 'Unable to Validate Security Code';
        funcRef = this.returnToLogin;
        fullError += '  Would you like to receive a new security code?';
        buttons = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Button, {
          key: "noButton",
          onClick: e => this.returnToLogin(e)
        }, "No"), /*#__PURE__*/_react.default.createElement(_core.Button, {
          key: "yesButton",
          onClick: e => this.resend(e)
        }, "Yes"));
      } else {
        uiErrorMessage = rawErrorMessage;
      }
      if (buttons) {
        errorModal = /*#__PURE__*/_react.default.createElement(_core.Modal, {
          header: header,
          key: "errorMmodal",
          closeModalCallback: e => {
            funcRef(e);
          },
          display: display,
          footer: /*#__PURE__*/_react.default.createElement(_core.Buttons, null, buttons)
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "is-3 has-text-left"
        }, decorateModalMessage(fullError)));
      }
    }
    if (!uiErrorMessage && errorMessage && typeof errorMessage === 'string') {
      uiErrorMessage = errorMessage;
    }
    return /*#__PURE__*/_react.default.createElement("div", null, errorModal, trustedDeviceModal, /*#__PURE__*/_react.default.createElement("div", {
      className: `lds-spinner-overlay ${isLoading && 'is-active'}`
    }, isLoading && /*#__PURE__*/_react.default.createElement(_core.Spinner, null)), /*#__PURE__*/_react.default.createElement("form", {
      id: "otpForm"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "login-box content"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "px-4"
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: "title"
      // eslint-disable-next-line react/no-danger
      ,
      dangerouslySetInnerHTML: {
        __html: _ApplicationContext.ApplicationContext.getSecurityCodeTitle() ? _dompurify.default.sanitize(_ApplicationContext.ApplicationContext.getSecurityCodeTitle()) : 'Security Code'
      }
    }), /*#__PURE__*/_react.default.createElement("p", {
      className: "subtitle has-text-left pb-4"
    }, deliveryMethodMessage), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control is-expanded has-icons-left"
    }, /*#__PURE__*/_react.default.createElement("input", {
      className: `input ${uiErrorMessage && 'is-danger'}`,
      type: "text",
      min: "0",
      max: "999999",
      placeholder: placeHolder,
      id: "otpCode",
      name: "otpCode",
      size: "15",
      onChange: e => this.change(e),
      onBlur: e => this.change(e),
      onKeyDown: e => this.onlyNumeric(e),
      value: otpCode,
      autoComplete: "one-time-code",
      required: true
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "icon is-small is-left"
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons"
    }, "lock")))), uiErrorMessage && decorateErrorMessage(uiErrorMessage), /*#__PURE__*/_react.default.createElement(_core.Field, {
      textAlign: "left",
      textSize: 3
    }, /*#__PURE__*/_react.default.createElement(_core.Control, null, /*#__PURE__*/_react.default.createElement(_core.Columns, null, /*#__PURE__*/_react.default.createElement(_core.Column, {
      isNarrow: true
    }, /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: "trust",
      className: "checkbox"
    }, /*#__PURE__*/_react.default.createElement("input", {
      id: "trust",
      type: "checkbox",
      name: "trust",
      onChange: e => this.change(e),
      onBlur: e => this.change(e)
    }), ' ', /*#__PURE__*/_react.default.createElement(_core.Span, {
      textWeight: "normal",
      textAlign: "left",
      mr: 0
    }, "Trust this device"))), /*#__PURE__*/_react.default.createElement(_core.Column, {
      textAlign: "left"
    }, /*#__PURE__*/_react.default.createElement("a", {
      role: "button",
      className: "checkbox has-text-link",
      tabIndex: -1,
      onKeyUp: () => this.setState({
        showTrustedDeviceModal: true
      }),
      onClick: () => this.setState({
        showTrustedDeviceModal: true
      })
    }, "Not sure what this does?"))))), /*#__PURE__*/_react.default.createElement("div", {
      className: "field field-submit-button"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "control"
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      className: "is-primary",
      handleClick: e => this.submit(e),
      disabled: disabled
    }, "Next"))), /*#__PURE__*/_react.default.createElement(_ResendSecurityCodeLink.default, {
      returnToLogin: this.returnToLogin,
      resend: this.resend,
      kbaAllowed: allowKbaLink,
      triggerKba: this.triggerKba
    })))));
  }
}
OtpVerificationStep.propTypes = {
  listener: _propTypes.default.func.isRequired,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired
  }),
  stepResponse: _propTypes.default.shape({
    additionalData: _propTypes.default.shape({
      message: _propTypes.default.string
    })
  })
};
var _default = exports.default = (0, _reactRouterDom.withRouter)(OtpVerificationStep);
//# sourceMappingURL=OtpVerificationStep.js.map